import styled from 'styled-components';
import theme from '../../utils/theme';

export const NavbarLateral = styled.div`
    background: ${theme.navbarBg};
    width: 180px;
    position: fixed !important;
    top: 0;
    left: 0;
    display: flex;
    height: 100vh;
    z-index: 100 !important;

    .svgMenu {
        display: none;
    }

    @media screen and (max-width: 1024px) {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        width: 100%;
        height: 10vh;

        .bodyLateral {
            height: 100%;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 1.5rem !important;

            .divLogo {
                max-height: 50px !important;
                padding-top: 5px !important;

                .logoA {
                    width: 60px !important;
                    height: 60px !important;

                    .logo {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }

        .employee,
        .redes,
        .navbar {
            display: none;
        }

        .svgMenu {
            display: block;
        }
    }
`;

export const Body = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media screen and (max-width: 1024px) {
        flex-direction: row;

        .active svg {
            fill: ${theme.azul} !important;
        }
    }
`;

export const DivLogo = styled.div`
    width: 100%;    
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 50px !important;

    svg {
        height: 100px;
        width: 100px;
        
        &:hover {
            cursor: pointer;
        }
    }

    @media screen and (max-width: 1024px) {
        max-height: 50px !important;
        width: auto;
        padding-top: 0 !important;

        &:nth-child(2) {
            margin-left: 20px !important;

            svg {
                height: 35px;
                width: 35px;
                fill: ${theme.letraClara};
                transition: all 800ms;
    
                &:hover {
                    cursor: pointer;
                }
            }
        }
    }
`;

export const Nav = styled.ul`
    width: 100%;
    height: auto;
    list-style: none;
    padding-top: 50px !important;
    margin: 0 !important;
    padding-left: 0 !important;

    li {
        height: 60px;
        border-top: 1px solid #282828;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #6D6D6D;
        font-size: 18px;
        font-family: "Open Sans", sans-serif;
        transition: color 500ms;

        &:hover {
            color: #28E885;
            cursor: pointer;
        }

        &:last-child {
            border-bottom: 1px solid #282828;
        }
    }

    .active {
        color: ${theme.verde};
        font-size: 22px;
    }
`;

export const NavResponsive = styled.ul`
    display: none;

    @media screen and (max-width: 1024px) {
        display: block;
        width: 100%;
        height: auto;
        list-style: none;
        padding: 0 !important;

        li {
            border-top: 1px solid #282828;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #6D6D6D;
            font-size: 16px;
            font-family: "Open Sans", sans-serif;
            transition: color 500ms;

            &:hover {
                color: #28E885;
                cursor: pointer;
            }

            &:last-child {
                border-bottom: 1px solid #282828;
            }
        }

        .active {
            color: ${theme.verde};
            font-size: 22px;
        }
    }
`;

export const Redes = styled.ul`
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    margin-top: 40px !important;
    list-style: none;
    padding: 0 !important;

    a {
        margin: 0 5px !important;

        svg {
            fill: #6D6D6D !important;
            transition: fill 500ms;
            width: 20px;
            height: auto;

            &:hover {
                fill: #28E885 !important;
            }
        }
    }
`;

export const RedesResponsive = styled.ul`
    display: none;

    @media screen and (max-width: 1024px) {
        margin-top: 10px !important;
        margin-bottom: 10px !important;
        display: flex;
        justify-content: center;
        flex-wrap: nowrap;
        align-items: center;
        height: 40px;
        width: 100%;
        padding: 0 !important;

        a {
            margin: 0 5px !important;

            svg {
                fill: #6D6D6D !important;
                transition: fill 500ms;
                width: 25px;
                height: auto;
    
                &:hover {
                    fill: #28E885 !important;
                }
            }
        }
    }
`;

export const Empleo = styled.span`
    height: 30px;
    font-size: 16px;
    color: ${theme.navbarText};
    font-weight: 600;
    padding-bottom: 60px !important;
    transition: color 500ms;
    width: 70%;
    text-align: center;
    font-family: "Funnel Sans", sans-serif;

    &:hover {
        color: ${theme.azul};
    }
`;

export const ContainerResponsiv = styled.div`
    display: none;
    
    @media screen and (max-width: 1024px) {
        display: block;
        width: 100% !important;
        height: auto;
        background: black;
        position: fixed;
        top: 10vh;
        left: -100%;
        z-index: 999;
        transition: left 500ms ease-in-out;
    }
`;